import { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useJob } from '../hooks/useJobs';
import { JobApplicationModal } from '../components/JobApplicationModal';

export function JobDetailPage() {
  const { id } = useParams<{ id: string }>();
  const { data: job, isLoading, isError, error } = useJob(id ?? '');
  const [showApply, setShowApply] = useState(false);

  if (!id) {
    return (
      <DetailShell>
        <p style={{ color: '#ff4d4f' }}>無效的职位 ID</p>
        <Link to="/jobs" style={{ color: '#1677ff' }}>← 返回列表</Link>
      </DetailShell>
    );
  }

  if (isLoading) {
    return (
      <DetailShell>
        <p style={{ textAlign: 'center', color: '#888' }}>加载中...</p>
      </DetailShell>
    );
  }

  if (isError || !job) {
    return (
      <DetailShell>
        <p style={{ color: '#ff4d4f' }}>
          載入失敗：{(error as Error)?.message ?? '职位不存在'}
        </p>
        <Link to="/jobs" style={{ color: '#1677ff' }}>← 返回列表</Link>
      </DetailShell>
    );
  }

  const salaryMin = job.salary.min.toLocaleString();
  const salaryMax = job.salary.max.toLocaleString();
  const salaryUnit =
    job.salary.unit === 'day' ? '日' : job.salary.unit === 'hour' ? '時' : '月';

  return (
    <>
      <DetailShell>
        {/* Back link */}
        <Link to="/jobs" style={{ color: '#1677ff', fontSize: 14, textDecoration: 'none', display: 'inline-block', marginBottom: 16 }}>
          ← 返回列表
        </Link>

        {/* Header */}
        <h1 style={{ fontSize: 20, fontWeight: 700, margin: '0 0 8px' }}>
          {job.title}
        </h1>
        <p style={{ fontSize: 14, color: '#666', margin: '0 0 4px' }}>
          🏢 {job.company.name}
        </p>
        <p style={{ fontSize: 14, color: '#666', margin: '0 0 4px' }}>
          📍 {job.location}
        </p>
        <p style={{ fontSize: 18, color: '#ff4d4f', fontWeight: 600, margin: '12px 0' }}>
          ${salaryMin} – ${salaryMax}/{salaryUnit}
        </p>

        <hr style={{ border: 'none', borderTop: '1px solid #eee', margin: '16px 0' }} />

        {/* Description */}
        <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>职位描述</h2>
        <p style={{ fontSize: 14, color: '#333', lineHeight: 1.6, margin: 0, whiteSpace: 'pre-wrap' }}>
          {job.description}
        </p>

        {/* Requirements */}
        <h2 style={{ fontSize: 16, fontWeight: 600, margin: '16px 0 8px' }}>要求</h2>
        <p style={{ fontSize: 14, color: '#333', lineHeight: 1.6, margin: 0, whiteSpace: 'pre-wrap' }}>
          {job.requirements}
        </p>

        {/* Apply button */}
        <button
          onClick={() => setShowApply(true)}
          style={{
            width: '100%',
            padding: '14px',
            fontSize: 16,
            fontWeight: 600,
            border: 'none',
            borderRadius: 8,
            background: '#1677ff',
            color: '#fff',
            cursor: 'pointer',
            marginTop: 24,
          }}
        >
          立即申請
        </button>
      </DetailShell>

      {/* JobApplicationModal */}
      {showApply && job && (
        <JobApplicationModal
          job={job}
          visible={showApply}
          onClose={() => setShowApply(false)}
          onSuccess={() => setShowApply(false)}
        />
      )}
    </>
  );
}

function DetailShell({ children }: { children: React.ReactNode }) {
  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5', padding: 16 }}>
      <div
        style={{
          background: '#fff',
          borderRadius: 10,
          padding: 20,
          boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
        }}
      >
        {children}
      </div>
    </div>
  );
}
